import { Content } from "@omni/ui/components/CallToAction/types/content.types";
import { cn } from "@omni/utils/styles";

type CallToActionContentProps = Content;

const CallToActionContent = ({
    text,
    iconClassName,
    iconPosition
}: CallToActionContentProps) => (
    <>
        {iconClassName && iconPosition === "start" && (
            <i className={cn("las la-lg mr-2", `la-${iconClassName}`)} />
        )}
        {text}
        {iconClassName && iconPosition === "end" && (
            <i className={cn("las la-lg ml-2", `la-${iconClassName}`)} />
        )}
    </>
);

export { CallToActionContent };
